export const CLOSE_TOUR = "CLOSE_TOUR";
